import { Feedback } from '~/models/feedback';

export const feedbackService = {
	send: async (
		source: string | null = 'Неизвестный источник',
		name: string = '-',
		phone: string = '-',
		email: string = '-',
		subject: string = '-',
		target: string | null = null
	): Promise<void> => {
		if (process.env.NODE_ENV === 'production') {
			await $fetch(Feedback.api, {
				method: 'POST',
				body: { source, name, phone, email, subject, target },
			});

			// @ts-ignore
			if (target && typeof ym === 'function') {
				// @ts-ignore
				ym(89991876, 'reachGoal', target);
				// console.info(`feedback.send: ${target}`);
			}
		}
	},
};
